import { TaskStatus } from '@ndvr/customer-api';

import { Badge } from '@/components/ui/badge';
import { titleCase } from 'utils';

interface TaskStatusBadgeProps {
    status: TaskStatus;
}

export const TaskStatusBadge = (props: TaskStatusBadgeProps) => {
    switch (props.status) {
        case TaskStatus.COMPLETED:
            return <Badge variant="success">{titleCase(props.status)}</Badge>;
        case TaskStatus.PENDING_WITH_CLIENT:
            return <Badge variant="secondary">{titleCase(props.status)}</Badge>;
        case TaskStatus.PENDING_WITH_ADVISOR:
            return <Badge variant="secondary">{titleCase(props.status)}</Badge>;
        case TaskStatus.PENDING_WITH_CUSTODIAN:
            return <Badge variant="secondary">{titleCase(props.status)}</Badge>;
        case TaskStatus.ON_HOLD:
            return <Badge variant="outline">{titleCase(props.status)}</Badge>;
        case TaskStatus.NEW:
            return <Badge variant="default">{titleCase(props.status)}</Badge>;
        case TaskStatus.IN_PROGRESS:
            return <Badge variant="mint">{titleCase(props.status)}</Badge>;
        default:
            return <Badge variant="default">{titleCase(props.status)}</Badge>;
    }
};
